<template>
  <div class="main">
    <ball></ball>
  <div>
      <van-nav-bar
      title="商品列表"
      left-arrow
      left-text="返回"
      @click-left="onClickLeft"
    />
  </div>

    <div class="list_body">
      <div class="list_body_list" v-for="(item,index) in productinfo" :key="index" @click="showpop(item)">
       <div class="list_body_img" >
          <van-image
        width="100"
        height="100"
        fit="fill"
        round
        :src="imgurl+item.GoodsID+'.jpg'"
      />
       </div>
      <div class="name">{{ item.GoodsName }}</div>
      <div class="tips">价格：{{ item.GoodsMoney }}元</div>
      </div>
         
    </div>
<van-popup v-model="show" round :style="{ height: '80vh',width:'80vw' }">
<div class="pop_detail">
<div class="pop_img">
    <van-image
        width="80vw"
        height="45vh"
        :src="imgurl+popitem.GoodsID+'.jpg'"
      />
</div>
<div class="pop_name">{{popitem.GoodsName}}</div>
<!-- <div class="pop_tips">简介：该商品啊实打实大是大实打实的撒的</div> -->
<div class="pop_money">价格：{{popitem.GoodsMoney}}元</div>
<div class="pop_btn">
  <van-button type="primary" block @click="AccordingGoodsCreateRecipe">确认下单</van-button>
  </div>
</div>

</van-popup>
    </div>
  </div>
</template>

<script>
import list from "@/components/productlist";
import Nav from "@/components/nav.vue";
import { Dialog } from "vant";
import setOptions from "@/mixins/setOption";
export default {
  mixins: [setOptions],
  data() {
    return {
      imgurl: "https://account.kmmds.top/datainfo_pic/ymwsy/",
      productinfo: null,
      imgsrc: "https://img01.yzcdn.cn/vant/cat.jpeg",
      show: false,
      popitem: {},
      medCardNo: "",
    };
  },
  components: {
    list,
    Nav,
  },
  mounted() {
    if (this.$route.query) {
      this.medCardNo = this.$route.query.clientId;
      this.name = this.$route.query.name;
      // console.log(this.medCardNo)
    }
    if (!this.medCardNo || this.medCardNo == "") {
      // console.log(this.medCardNo);
      this.goconfUser();
      // this.Dialog();
    }
    this.LoadGoodsList();
  },
  methods: {
    goconfUser() {
      this.$router.push("/patient_card_selectuser");
    },
    async AccordingGoodsCreateRecipe() {
      console.log(this.popitem, this.medCardNo);
      try {
        this.$showLoad();
        let url = "/outpatientfee/AccordingGoodsCreateRecipe";
        let data = {
          GoodsID: this.popitem.GoodsID,
          GoodsMoney: this.popitem.GoodsMoney,
          PatientID: this.medCardNo,
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            if (data.data.data.ResultCode == 0) {
              this.$router.push({
                path: "/pay_list_D",
                query: {
                  clientId: this.medCardNo,
                  name: this.name,
                },
              });
            } else {
              this.$toast.fail("下单失败，稍后重试");
            }
          }
        );
      } catch (error) {}
    },
    showpop(item) {
      this.popitem = item;
      console.log(this.imgurl + item.GoodsID + ".jpg");

      this.show = true;
    },
    onClickLeft() {
      this.$router.push("/index");
    },
    async LoadGoodsList() {
      try {
        this.$showLoad();
        let url = "/outpatientfee/LoadGoodsList";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.$hideLoad();
            this.productinfo = data.data.data.List.Item;
          }
        );
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  height: 8vh;
  width: 100%;
}
.pop_detail {
  display: flex;
  flex-direction: column;
  font-size: 16px;
  padding: 2vw;
  .pop_img {
    width: 100vw;
    height: 45vh;
  }
  .pop_name {
    margin-top: 1vh;
  }
  .pop_tips {
    margin-top: 1vh;
  }
  .pop_money {
    margin-top: 1vh;
  }
  .pop_btn {
    margin-top: 6vh;
  }
}
.list_body {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-height: 90vh;
  overflow-y: auto;
  .list_body_list {
    justify-items: center;
    border: 1px solid rgb(241, 241, 241);
    width: 50vw;

    .list_body_img {
      width: 100px;
      margin: 0px auto;
    }
    .name {
      width: 100px;
      text-align: center;
      font-size: 16px;
      margin: 0px auto;
      margin-top: 2vh;
    }
    .tips {
      width: 100px;
      text-align: center;
      font-size: 16px;
      justify-content: center;
      margin: 0px auto;
      margin-top: 2vh;
    }
  }
}
</style>